import { useState, useEffect } from 'react';
import { ContractService } from '../../../core/services/ContractService';
import { Singleton } from '../../../core/services/Singleton';
interface Props {
    idSelector: number;
    onChange: any;
    _year?: number;
    StatePlans?: number;
    label?: string;
}
export const SelectAdquisitionPlan = ({ idSelector, onChange, _year, StatePlans = 2, label }: Props) => {

    const single = Singleton.getInstance();
    const service = new ContractService();
    const [lista, setLista] = useState([]);
    const [id, setID] = useState(undefined);
    const [year, setYear] = useState(single.getCurrenYear());


    useEffect(() => {
        if (idSelector != id)
            setID(idSelector);
    }, [idSelector])

    useEffect(() => {
        getLista();
    }, [_year])

    const setValue = (e: any) => {
        setID(e);
        onChange?.(e)
    }

    const getLista = () => {
        //console.log("Plan de adquisicion : ", _year ?? year);
        service.getAdquisitionPlanCatalog(_year ?? year, _year ?? year, StatePlans, null, null).subscribe(
            (resp: any) => {
                // setLista([]);
                if (resp.DataBeanProperties.ObjectValue.DataBeanProperties.List) {
                    setLista(resp.DataBeanProperties.ObjectValue.DataBeanProperties.List);
                }
            }
        );
    }

    return (
        <>
            <label>{label ?? "Plan de Adquisición"}</label>
            <select className="form-select" value={id} onChange={(e) => {
                const valor = e.target.value ? Number(e.target.value) : null;
                setValue(valor)
            }}>
                <option value={""}>...</option>
                {lista &&
                    lista.map((item: any) => {
                        return (
                            <option key={item.DataBeanProperties.IDAdquisitionPlan} value={item.DataBeanProperties.IDAdquisitionPlan} >{item.DataBeanProperties.Description}</option>
                        )
                    })
                }
            </select>
        </>
    )
}